module.exports = __webpack_public_path__ + "static/media/badge5.9b07db97.svg";